module.exports = __webpack_public_path__ + "img/classsearchnone.b4959df0.png";